import loadable from '@loadable/component';
import './RatedStars.css';

export default loadable(() => {
  return import('./RatedStars.jsx');
});
